export default {
  title: 'You are almost done!',
  subtitle: 'Enter your Billing Address',
  country: 'Country',
  firstAddress: 'Address 1',
  firstStreet: 'Street address or P.O. Box',
  secondAddress: 'Address 2 (Optional)',
  secondStreet: 'Apartment, suite, etc.',
  city: 'City',
  enterCity: 'Enter City here',
  state: 'State',
  postalCode: 'Postal/ZIP Code',
  enterCode: 'Enter Postal/Zip Code here',
  getPlan: 'Get my plan',
}
